module.exports = __webpack_public_path__ + "static/img/mustardSeedTestimonial.917b7ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/mustard-seed/mustardSeedTestimonial.jpg
// module id = 50
// module chunks = 0